import { List, Datagrid, NumberField, TextField, EditButton } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useRouteId } from "@/utils/route-utility";

export const ProjectKarzanRepaymentList = () => {
  const projectId = useRouteId();
  if (!projectId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Open a project from the Projects list to view repayments.
        </Typography>
      </Box>
    );
  }
  return (
    <List perPage={25} sort={{ field: "repaymentDate", order: "DESC" }} filter={{ projectId }}>
      <Datagrid rowClick="edit">
        <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
        <DisplayDateField source="repaymentDate" />
        <TextField source="remarks" emptyText="—" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
